import { Clock } from 'lucide-react';
import { tableTypographyTier } from '../../utils/restaurantFloorPlan';

const TIER = {
  xs: {
    name: 'text-[10px] font-bold leading-tight',
    meta: 'text-[8px] leading-tight',
    icon: 14,
    gap: 'gap-0.5',
    pad: 'px-1 py-0.5',
  },
  sm: {
    name: 'text-xs font-bold leading-tight',
    meta: 'text-[9px] sm:text-[10px] leading-tight',
    icon: 17,
    gap: 'gap-0.5',
    pad: 'px-1.5 py-0.5',
  },
  md: {
    name: 'text-sm font-bold leading-snug',
    meta: 'text-[10px] sm:text-xs leading-snug',
    icon: 20,
    gap: 'gap-1',
    pad: 'px-2 py-1',
  },
  lg: {
    name: 'text-base font-bold leading-snug',
    meta: 'text-xs leading-snug',
    icon: 24,
    gap: 'gap-1',
    pad: 'px-2 py-1',
  },
};

/**
 * Contenu centré d'une table (plan + config) — libellé, statut, capacité, service.
 */
export default function RestaurantTablePlanVisual({
  row,
  layout,
  meta,
  cap,
  mode,
  moduleResaOk,
  resaList,
  formatResaTime,
  formatElapsed,
}) {
  const tierKey = tableTypographyTier(layout.width, layout.height);
  const tier = TIER[tierKey];

  const showClock = row.openSession && mode === 'plan';
  const showResa =
    moduleResaOk && resaList.length > 0 && row.operationalStatus !== 'OCCUPIED';

  return (
    <div
      className="pointer-events-none absolute inset-0 flex items-center justify-center"
      data-testid="restaurant-table-plan-info"
    >
      <div
        className={`flex max-h-full w-full max-w-[92%] flex-col items-center justify-center text-center ${tier.pad} ${tier.gap}`}
      >
        <p
          data-testid="restaurant-table-plan-label"
          className={`${tier.name} w-full break-words [overflow-wrap:anywhere] line-clamp-2`}
        >
          {row.table.label}
        </p>

        <div className="flex w-full items-center justify-center gap-1">
          <span className={`inline-block h-1.5 w-1.5 shrink-0 rounded-full ${meta.dot}`} aria-hidden />
          <span className={`${tier.meta} font-medium`}>{meta.label}</span>
        </div>

        <p
          className={`${tier.meta} w-full ${cap.over ? 'font-medium text-amber-800' : 'text-inherit opacity-90'}`}
        >
          {cap.text}
        </p>

        {showResa && (
          <p className={`${tier.meta} w-full font-medium text-violet-800 line-clamp-1`}>
            Résa {formatResaTime(resaList[0]?.heureArrivee)}
          </p>
        )}

        {showClock && (
          <p className={`${tier.meta} flex w-full items-center justify-center gap-0.5`}>
            <Clock className="shrink-0" style={{ width: tier.icon * 0.75, height: tier.icon * 0.75 }} />
            <span className="tabular-nums">{formatElapsed(row.openSession.openedAt)}</span>
          </p>
        )}
      </div>
    </div>
  );
}
